/*
 * 상담 문의·제휴 신청을 sub-erp 백엔드(api.offer-group.com)로 보낸다.
 *
 * 전송 주소는 빌드 시점의 REACT_APP_API_URL 이다. 운영 빌드는 배포 워크플로
 * (.github/workflows/deploy.yml)가 넣는다.
 * 로컬 개발에서 이 값이 없으면 실제로 보내지 않고 성공만 흉내 낸다.
 * 실제 전송을 시험하려면 .env.development.local 에 REACT_APP_API_URL 을 넣는다.
 */

const API_URL = process.env.REACT_APP_API_URL;

/** 폼 값 → 서버 필드. 이름은 customerName 으로 보낸다(서버 로그에서 가려지는 필드명). */
const toPayload = {
  contact: (v) => ({
    customerName: v.name,
    phone: v.phone,
    company: v.company,
    topic: v.topic,
    amount: v.amount,
    message: v.message,
    agree: v.agree,
  }),
  partner: (v) => ({
    customerName: v.manager,
    phone: v.phone,
    email: v.email,
    company: v.company,
    topic: v.kind,
    message: v.proposal,
    agree: v.agree,
  }),
};

/** kind: 'contact' | 'partner' */
export default async function submitInquiry(kind, values) {
  if (!API_URL) {
    // 운영에서 주소 없이 성공을 흉내 내면 문의가 조용히 사라진다. 실패로 알려 전화번호 안내가 뜨게 한다.
    if (process.env.NODE_ENV === 'production') {
      throw new Error('REACT_APP_API_URL 없이 빌드되어 문의를 보낼 곳이 없습니다.');
    }
    console.warn(`[offergroup] REACT_APP_API_URL 이 없어 ${kind} 폼을 전송하지 않았습니다.`, values);
    await new Promise((resolve) => setTimeout(resolve, 600));
    return { ok: true, simulated: true };
  }

  const res = await fetch(`${API_URL}/homepage/${kind}`, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify(toPayload[kind](values)),
  });
  if (!res.ok) throw new Error(`접수 실패 (${res.status})`);
  return res.json();
}
